import {useState} from 'react'
import InternalInspcectionForm  from "./InternalInspcectionForm";
import InternalInspcectionList from './InternalInspcectionList';

const ProInternalInspcection = () => {
  const [fromIsShown, setFromIsShown] = useState(false);
  const [upData, setUpData] = useState(false);

return (
  <>
    {fromIsShown ? (
        <InternalInspcectionForm addForm={setFromIsShown} update={upData} />
      ) : (
        <InternalInspcectionList addForm={setFromIsShown} update={setUpData} />
      )}

  </>
  )
}

export default ProInternalInspcection